import { Controller } from '@hotwired/stimulus'
import { render } from 'nunjucks'

import {
    loginPostRequest
} from '../api'

import { Events, Forms, Dbs } from '../constants'

import { router, Routes } from '../router'

import {db, updateSession} from '../utils'

import {
    addClass,
    removeClass,
    subscribeEvent,
    target,
    unsubscribeEvent,
    sendEvent,
    isLoggedIn,
    notifier
} from '../utils'

export default class extends Controller {

    static targets = [
        'dialog',
        'form',
        'rpe',
        'password',
        'clock',
        'submit'
    ]

    static values = {
        show: Boolean
    }

    state = {
        showValue: false
    }

    instances = {
        validator: null
    }

    dialog = () => target(this, 'dialog')

    form = () => target(this, 'form')

    rpe = () => target(this, 'rpe')

    password = () => target(this, 'password')

    clock = () => target(this, 'clock')

    submit = () => target(this, 'submit')

    initialize = () => {

        this.state.showValue = false

        this.instances.validator = new Validator(this.form(), this.login, Forms)

        this.clock().W3FClockTimer({
            step: 30000
        })
    }

    connect = () => {

        subscribeEvent(Events.SHOW_LOGIN, this.open)
        subscribeEvent(Events.HIDE_LOGIN, this.close)

        this.checkLogin()
    }

    disconnect = () => {

        unsubscribeEvent(Events.SHOW_LOGIN, this.open)
        unsubscribeEvent(Events.HIDE_LOGIN, this.close)
    }

    checkLogin = () => {

        isLoggedIn().then((isLoggedIn) => {

            if (! isLoggedIn) {

                sendEvent(Events.SHOW_LOGIN, { message: '' })
            }

        }).catch(() => {

            sendEvent(Events.SHOW_LOGIN, { message: '' })
        })
    }

    open = ({ detail: { message }}) => {

        this.state.showValue = true

        if (this.state.showValue) {

            removeClass(this.dialog(), 'is-hidden')
        }
    }

    close = () => {

        this.state.showValue = false

        if (! this.state.showValue) {

            addClass(this.dialog(), 'is-hidden')
        }
    }

    login = (errors, isValid) => {

        if (! isValid) {

            return
        }

        const form = new FormData(this.form())

        const params = Object.fromEntries(form.entries())

        loginPostRequest(params)
            .then(this.onLogin)
            .catch(this.onLogin)
    }

    onLogin = (response) => {

        if (response.estado) {

            const form = new FormData(this.form())

            const params = Object.fromEntries(form.entries())

            updateSession(params).then(() => {

                notifier.info(response.mensaje)

                sendEvent(Events.ON_LOGIN)

                this.close()

                router.navigate(Routes[1].url, {
                    historyAPIMethod: 'replaceState'
                })

            }).catch(() => {})
        }
    }
}
